import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=621f7e48&scoped=true"
import script from "./Switch.vue?vue&type=script&lang=ts"
export * from "./Switch.vue?vue&type=script&lang=ts"
import style0 from "./Switch.vue?vue&type=style&index=0&id=621f7e48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621f7e48",
  null
  
)

export default component.exports